<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input
              id="filter-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Qidiruv...')"
              class="modern-search"
            >
          </div>

          <!-- Yangilash -->
          <button class="refresh-btn" @click="Data()" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <!-- Qo'shish -->
          <button class="add-btn" @click="Href('/malumot/user/create')" v-if="rule.change==true">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}<sup>ins</sup>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th>{{ $t('FOYDALANUVCHI') }}</th>
                <th>{{ $t('SKLAD') }}</th>
                <th style="width: 120px; text-align: center;">{{ $t('AMALLAR') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in filteredRows"
                :key="item.id"
                @dblclick="Update(item)"
              >
                <td>
                  <span class="id-badge">#{{ index + 1 }}</span>
                </td>
                <td class="font-bold">{{ item.username }}</td>
                <td>
                  <span v-if="item.sklad">{{ item.sklad.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <div class="actions" v-if="rule.change==true">
                    <button class="icon-btn edit" @click="$router.push('/malumot/user/update/' + item.id)">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="4" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ totalRows }}</b> ta foydalanuvchi
          </div>
          <div v-if="totalRows > perPage">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from "../../Layout/Top.vue";
import { print } from "../../../components/mixins/print.js";
import filterFunction from "../../../utils/filterFunction";

export default {
  components: { Top },
  mixins: [print],
  data() {
    return {
      items: [],
      filter: "",
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterOn: []
    };
  },
  computed: {
    filteredRows() {
      let rows = this.items;
      if (this.filter && this.filter.length > 1) {
        const q = this.filter.toLowerCase();
        rows = rows.filter(row =>
          (row.username && row.username.toLowerCase().includes(q)) ||
          (row.sklad && row.sklad.name && row.sklad.name.toLowerCase().includes(q))
        );
      }
      this.totalRows = rows.length;
      const start = (this.currentPage - 1) * this.perPage;
      return rows.slice(start, start + this.perPage);
    }
  },
  created() {
    this.Data();
  },
  methods: {
    filterFunction,
    Update(record) {
      if (this.rule.open == true) {
        this.$router.push({ path: '/malumot/user/update/' + record.id });
      }
    },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/users",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          self.items = response.data;
          self.totalRows = self.items.length;
        })
        .catch(function(error) {
          self.errors = error.message;
        });
    },
    Trash(id) {
      let self = this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
        if (text == self.update_password) {
          axios({
            method: "delete",
            url: "api/v1/users/id/" + id
          }).then(function(response) {
            self.Data();
          });
        } else {
          self.$store.state.errors = self.$t("Парол хато");
        }
      })
      .catch(function() {});
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.refresh-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.custom-table tbody tr:hover {
  background: #faf8ff;
  cursor: pointer;
}

/* ID BADGE */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

.text-muted {
  color: #94a3b8;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .modern-search {
    width: 100%;
  }
}
</style>
